<template>
    <div>
        <div v-if="!$route.path.includes('sessions') && !$route.path.includes('set-sec-password') && !$route.path.includes('register')">
            <!-- Footer Start -->
            <div class="footer_wrap" ref="footer">
                <div class="app-footer">
                    <b-row align-h="around" class="">
                        <b-col cols="2" class="position-relative ">
                            <router-link tag="a" to="/web/homepage" class="nav-item-hold">
                                <div class="box">
                                    <img :src="currentPath == 'homepage' ? require('../assets/images/footer/home_a.png') : require('../assets/images/footer/home.png')"
                                        class="nav-icon" />
                                </div>
                                <div class="footer-text" :class="['nav-text', { active: currentPath == 'homepage' }]">
                                    <span>{{ $t('home') }}</span>
                                </div>
                            </router-link>
                        </b-col>
                        <b-col cols="2" class="">
                            <router-link tag="a" to="/web/membership" class="nav-item-hold">
                                <div class="box">
                                    <img :src="currentPath == 'membership' ? require('../assets/images/footer/membership_a.png') : require('../assets/images/footer/membership.png')"
                                        class="nav-icon" />
                                </div>
                                 <div class="footer-text" :class="['nav-text', { active: currentPath == 'membership' }]">
                                    <span>{{ $t('membership') }}</span>
                                </div>
                            </router-link>
                        </b-col>
                        <b-col cols="2" class="">
                            <a @click="toMall" class="nav-item-hold">
                                <div class="box">
                                    <div class="mall-icon">
                                        <img :src="require('../assets/images/footer/mall.png')"
                                            class="mall-img" />
                                    </div>
                                </div>
                                 <div class="footer-text" :class="['nav-text', { active: currentPath == 'mall' }]">
                                    <span>{{ $t('mall') }}</span>
                                </div>
                            </a>
                        </b-col>
                        <b-col cols="2" class="">
                            <router-link tag="a" to="/web/ib_tree" class="nav-item-hold">
                                <div class="box">
                                    <img :src="currentPath == 'ib_tree' ? require('../assets/images/footer/network_a.png') : require('../assets/images/footer/network.png')"
                                        class="nav-icon" />
                                </div>
                                 <div class="footer-text" :class="['nav-text', { active: currentPath == 'ib_tree' }]">
                                    <span>{{ $t('network') }}</span>
                                </div>
                            </router-link>
                        </b-col>

                        <b-col cols="2" class="">
                            <router-link tag="a" to="/web/profile" class="nav-item-hold">
                                <div class="box">
                                    <img :src="currentPath == 'profile' ? require('../assets/images/footer/me_a.png') : require('../assets/images/footer/me.png')"
                                        class="nav-icon" />
                                </div>
                                <div class="footer-text" :class="['nav-text', { active: currentPath == 'profile' }]">
                                    <span>{{ $t('me') }}</span>
                                </div>
                            </router-link>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>
       <div>
 
        <div>
            <div class="support-tab-line d-flex align-items-center justify-content-center" @click="showSupport = !showSupport" >
                <img src="./../assets/images/action/back.png">
            </div>
            <transition name="slide-fade">
                <div
                    v-if="showSupport"
                    class="support-panel"
                    @click.stop
                >
                    <b-button id="support-btn" variant="light" class="support-button" @click="showSupport = false; $bvModal.show('cs')">
                    <img src="./../assets/images/action/support-icon.png" alt="" height="32px" width="auto" />
                    <div class="text-12 text-primary font-weight-700">{{ $t('support') }}</div>
                    </b-button>
                </div>
            </transition>

            <b-modal id="cs" :title="$t('customer_support')" hide-footer centered>
                <div class="d-flex flex-column align-items-center">
                    <div class="d-flex flex-column align-items-center mb-4">
                        <img src="./../assets/images/action/cs-img.png" alt="" height="88px" width="auto" />
                        <div class="cs-text mt-3">{{ $t('cs_text') }}</div>
                    </div>
                    <b-row no-gutters class="w-100">
                        <b-col cols='6'>
                            <b-button
                                block
                                variant="primary"
                                class="d-flex align-items-center justify-content-center mr-2 text-16 font-weight-600"
                                style="border: none !important; height: 44px;"
                                href="https://wa.me/601168699686"
                                target="_blank"
                                >
                                <img src="../assets/images/action/whatsapp-cs.png" class="mr-1" />
                                {{ $t('whatsapp_us') }}
                            </b-button>
                        </b-col>
                        <b-col cols="6">
                            <b-button
                                block
                                variant="primary"
                                class="d-flex align-items-center justify-content-center flex-fill ml-2 text-16 font-weight-600"
                                style="border: none !important; height: 44px;"
                                href="mailto:cs@jclub.com.my"
                                >
                                <img src="../assets/images/action/email-cs.png" class="mr-1" />
                                {{ $t('email_us') }}
                            </b-button>
                        </b-col>
                    </b-row>
                </div>
            </b-modal>
        </div>
    </div>


    </div>

</template>
<script>
export default {
    computed: {
        currentPath() {
            return this.$route.path.split('/')[2]; 
        }
    },
    data() {
        return {
            showSupport: false
        };
    },
    methods: {
        
        toMall() {

            var token = localStorage.getItem('currencyToken');
            var lang = localStorage.getItem('lan');
            var baseUrl;
            if (window.location.hostname === 'jclub.com.my' || window.location.hostname === 'www.jclub.com.my') {
                baseUrl = "https://mall.jclub.com.my/web/sessions/login";
            } else if (window.location.hostname === 'jaboclub.com') {
                baseUrl = "https://mall.jaboclub.com/web/sessions/login";
            } else {
                baseUrl = "https://uatmall.jclub.com.my/web/sessions/login";
            }

            if (token) {
                var url = baseUrl + "?key=" + encodeURIComponent(token) + "&lan=" + encodeURIComponent(lang);
                window.location.href = url;
            } else {
                console.error('Token not found in localStorage');
            }
        },
    }

}
</script>